import chart from './components/chart'
import modal from './components/modal'
import user from './components/user'
import geolocation from './components/geolocation'
import backgroundBanner from './components/background-banner'
import alertNews from './components/alert-news'
import calendar from './components/calendar'
import header from './components/header'

alertNews.getNewestAlert()
alertNews.closeAlert()
backgroundBanner.renderBackgroundBanner()
chart.controlVariableChart()
calendar.initCalendar()
geolocation.userGeolocation()
modal.controlModal()
user.userInfo()
user.controlLoggedMenu()
user.controlFavoritesLocalesBreadcrumb()
header.controlMenu()
